<template>
    <div :class="['rating-banner', { webmaster: isWebmasterRole, admin: !isWebmasterRole }]">
        <div class="rating-banner_wrapper-info is-relative">
            <img
                alt="logo"
                class="rating-banner_left-img"
                :src="bgImage">
            <img
                alt="logo"
                class="rating-banner_left-img-mobile"
                src="@/assets/Competition/Raffle/left-section/Banner-Mobile.png">

            <CompetitionPresentItem
                :key="present"
                v-for="present in [1, 2, 3]"
                :place="present"
                :class="`present-${ present } present is-absolute`">
            </CompetitionPresentItem>
        </div>

        <CompetitionMain class="dashboard-main"></CompetitionMain>

        <CompetitionRatingButtons
            v-if="isWebmasterRole"
            class="dashboard-buttons">
        </CompetitionRatingButtons>

        <CompetitionRatingPrizesCard></CompetitionRatingPrizesCard>

        <img
            alt="gray-blot"
            class="gray-blot"
            src="@/assets/Competition/Raffle/additional-info/gray-blot.svg">

        <CompetitionModal v-if="isWebmasterRole"></CompetitionModal>
    </div>
</template>

<script>
  import CompetitionRatingPrizesCard from "@/components/Common/Competition/CompetitionRatingPrizesCard.vue";
  import CompetitionRatingButtons from "@/components/Common/Competition/CompetitionRatingButtons.vue";
  import CompetitionModal from "@/components/Webmaster/Dashboard/Competition/CompetitionModal.vue";
  import CompetitionPresentItem from "@/components/Common/Competition/CompetitionPresentItem.vue";
  import CompetitionMain from "@/components/Common/Competition/CompetitionMain.vue";
  import { formatEmptyString } from "@/filters";
  import { mapGetters, mapState } from "vuex";
  import { encodeFilters } from "@core/filters";

  export default {
    name: "CompetitionRatingBanner",

    components: {
      CompetitionMain,
      CompetitionRatingPrizesCard,
      CompetitionModal,
      CompetitionRatingButtons,
      CompetitionPresentItem
    },

    computed: {
      ...mapGetters(["role"]),

      ...mapState("competition", {
        currentCompetition: ({ currentCompetition }) => currentCompetition
      }),

      bgImage () {
        return require(`@/assets/Competition/Raffle/left-section/${ !this.isWebmasterRole ? "admin" : "left" }-img.png`);
      },

      isWebmasterRole () {
        return this.role === "webmaster";
      }
    },

    methods: {
      encodeFilters,
      formatEmptyString
    }
  };
</script>

<!--suppress SassScssResolvedByNameOnly -->
<style scoped lang="scss">
  @import "~@/scss/competition-banner";

  .admin {
    &.rating-banner {
      max-height: 240px;

      @media screen and (max-width: 960px) {
        min-height: 170px !important;
      }
    }

    ::v-deep {
      .present-2 {
        left: clamp(1.25rem, -2.739rem + 5.1471vw, 3.4375rem);
        top: 110px;
      }
      .present-1 {
        left: clamp(9.0625rem, -2.3346rem + 14.7059vw, 15.3125rem);
        top: 130px;
      }
      .present-3 {
        left: clamp(17.8125rem, -0.9926rem + 24.2647vw, 28.125rem);
        top: 110px;
      }

      .gray-blot {
        height: 280px;
      }

      @media screen and (max-width: 960px) {
        .print {
          display: none;
        }
      }

      .rating-banner_left-img {
        margin-left: clamp(-5rem, -14.1176rem + 11.7647vw, 0rem) !important;
      }

      .rating-prizes {
        &_t-shirt,
        &_glove {
          margin-top: -35px;
        }
        &_suitcase {
          width: clamp(11.875rem, 9.5956rem + 2.9412vw, 13.125rem);
          margin-top: 10px;
        }
      }

      .competition-main {
        .date {
          width: clamp(5.625rem, 1.9779rem + 4.7059vw, 7.625rem);
          margin-bottom: 5px;
        }
        .logo {
          width: clamp(12.8125rem, 4.2647rem + 11.0294vw, 17.5rem);
          margin-bottom: 0;
        }
        .plus {
          display: none;
        }
      }
    }
  }

  .competition-main {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }

  .present-1 {
    top: clamp(8.125rem, -2.8766rem + 14.1159vw, 14.0625rem); // 225px
    left: clamp(8.75rem, -8.0419rem + 21.5453vw, 17.8125rem); // 285px
  }
  .present-2 {
    top: clamp(7.5rem, 2.8678rem + 5.9435vw, 10rem); // 160px
    left: clamp(17.8125rem, -10.56rem + 36.4042vw, 33.125rem); // 530px
  }
  .present-3 {
    top: clamp(7.5rem, 2.8678rem + 5.9435vw, 10rem); // 160px
    left: clamp(1rem, -1.7793rem + 3.5661vw, 2.5rem); // 40px
  }

  .gray-blot {
    position: absolute;
    right: 0;
    z-index: 0;

    width: clamp(20.3125rem, 1.4361rem + 24.2199vw, 30.5rem); // 488px
    height: clamp(15rem, 1.1033rem + 17.8306vw, 22.5rem); // 360px
  }

  .dashboard-buttons {
    display: none;
  }

  .columns:not(:last-child) {
    margin-bottom: -0.75rem !important;
  }

  .pre-wrap {
    white-space: pre;
  }

  .rating-banner {
    $self: &;

    #{$self}_info {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }

    #{$self}_left-img {
      margin-left: clamp(-1.5rem, -4.2793rem + 3.5661vw, 0rem);
      height: 100%;
    }
  }

  .rating-banner_left-img-mobile {
    display: none;
  }

  @media screen and (max-width: 960px) {
    .dashboard-buttons {
      display: flex;
      position: absolute;
      bottom: 15px;
      left: 50%;
      transform: translate(-50%, 0);
    }

    .dashboard-main {
      top: 20px;
      transform: translate(-50%, 0);

      ::v-deep {
        .date {
          width: clamp(4.625rem, -0.375rem + 10vw, 5.625rem) !important;
          height: clamp(1.1875rem, -0.0625rem + 2.5vw, 1.4375rem) !important;
        }
        .logo {
          width: clamp(10.875rem, 1.1875rem + 19.375vw, 12.8125rem) !important;
          height: clamp(5.125rem, 0.4375rem + 9.375vw, 6.0625rem) !important;
        }
        .plus {
          margin-bottom: 2px
        }
      }
    }

    .rating-banner_left-img-mobile {
      display: block;
    }

    .rating-banner_left-img,
    .gray-blot,
    .present {
      display: none;
    }
  }
</style>
